import { API_AUTH_LOGIN, API_USER_VOTE } from "config/api.url.constant"
import Api from "services/api"

export const login = async (data: any) => {
    const currentTime = new Date();
    const today =
        currentTime.getFullYear() +
        "-" +
        (currentTime.getMonth() + 1) +
        "-" +
        currentTime.getDate();
    return Api.post(API_AUTH_LOGIN, { ...data, time: today })
}

export const doVote = async (data: { time: string }) => {
    return Api.post(API_USER_VOTE, data)
}